import m from "mithril";
import {defineWidget} from "@nebularstreams/libmui";

const
	TitleBarWidget = defineWidget(
		({attrs}) => m("header.col-12.noselect", {id: "header"}, [
			m("div", [
				m(".header-title", [
//					m("a", {disabled_href: "https://www.nanocosmos.de/v6/"}, [
					m("img", {src: "../assets/images/nsc.png", className: "nano-logo", alt: "nanocosmos"}),
//					]),
					...attrs.rootTitle ? [m("h3", {onclick: attrs.rootTitleClick}, attrs.rootTitle)] : [],
					...attrs.title ? [m("h3.grows.apptitle", attrs.title)] : [m(".grows", "")],
					...attrs.help ? [m("a", {target: "help", href: "help"}, "Help")] : [],
					...attrs.version ? [m("span", {id: "version"}, "version " + attrs.version)] : []
				])
			])
		])
	);

export {TitleBarWidget};
